import { useEffect, useState } from 'react';

export function useBannerSize() {
  const [small, setSmall] = useState(false);
  useEffect(() => {
    const update = () => setSmall(window.innerHeight <= 700);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return small
    ? { h: '46px', fontSize: 'lg' as const, largeFontSize: 'xl' as const }
    : { h: '60px', fontSize: 'xl' as const, largeFontSize: '2xl' as const };
}
